import { EvComboboxOption } from '@evinced-private/ui-common';

import { ITenantMemberUser } from 'src/interfaces/TenantMember';

export const getUserLabel = ({ name, surname, email }: ITenantMemberUser): string => {
	if (name && surname) {
		return `${name} ${surname} (${email})`;
	}
	return email;
};

export const mapUsersToOptions = (
	users: ITenantMemberUser[],
	disabledIds: Set<string>
): EvComboboxOption[] =>
	users.map((user) => ({
		label: getUserLabel(user),
		value: user.id,
		disabled: disabledIds.has(user.id)
	}));
